import { Reducer } from 'interfaces'
import { Offer, OffersDataState } from 'interfaces/offers'
import { setItemInCollection } from 'helpers/normalizeHelpers'
import { GET_OFFER } from 'actions/offersActions'
import { isFailAction, isSuccessAction } from 'helpers/actionsHelpers'
import { createNotFoundEntity } from 'helpers/entityHelpers'
import { NotFoundEntity } from 'interfaces/entity'

const offersDataReducer: Reducer<OffersDataState | null> = (state = null, action) => {
  if (action.type === GET_OFFER && isSuccessAction(action)) {
    return setItemInCollection<Offer | NotFoundEntity, 'id'>(state, action.payload.response, 'id')
  }

  if (action.type === GET_OFFER && isFailAction(action)) {
    const item = createNotFoundEntity(action.payload.params.id)
    return setItemInCollection<Offer | NotFoundEntity, 'id'>(state, item, 'id')
  }

  return state
}

export default offersDataReducer
